// extracted by mini-css-extract-plugin
export default {"fr-view":"GamePodium_fr-view__iK7xs","podium":"GamePodium_podium__EjpzE"};